import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Mapped, Silent } from "@/__main__/data-model.mjs";

const columnModel = {
  name: String,
  position: Number,
  typeName: String,
  typeText: String,
};

const ChampionResult = {
  champion_ids: String,
  stats: Mapped({
    key: String,
    value: Number,
  }),
  patch: String,
  dt: String,
  dummy: String,
} satisfies ModelDefinition;

const ChampionsModel = createModel({
  data: {
    executeDatabricksQuery: {
      payload: {
        manifest: {
          schema: {
            columnCount: Number,
            columns: [columnModel],
          },
        },
        result: {
          chunkIndex: Silent(Number),
          dataArray: [[String]],
          rowCount: Silent(Number),
          rowOffset: Silent(Number),
        },
      },
    },
  },
}).transform([ChampionResult], (data) => {
  const {
    data: { executeDatabricksQuery },
  } = data;

  const { columns = [] } =
    executeDatabricksQuery?.payload?.manifest?.schema || {};

  const list = executeDatabricksQuery?.payload?.result?.dataArray || [];

  const champions = list.map((c) => {
    const result = {
      champion_ids: "",
      stats: {
        top_4_percent: 0,
        tier: 0,
        top_teammates: 0,
        match_pick_rate: 0,
        top_1_percent: 0,
        num_duos: 0,
        num_games: 0,
        pick_rate: 0,
        avg_placement: 0,
        ban_rate: 0,
        top_2_percent: 0,
      },
      patch: "",
      dt: "",
      dummy: "",
    };
    for (const column of columns) {
      if (!result.hasOwnProperty(column.name)) continue;
      const value: string = (c[column.position] || "") as unknown as string;
      result[column.name] = castType(column.typeName, value);
    }

    return result;
  });

  return champions;
});

export default ChampionsModel;

export type ArenaChampionsDuosStats = FromModel<typeof ChampionsModel>;

function castType(typeText: string, value: string) {
  switch (typeText) {
    case "BOOLEAN":
      return value === "true";
    case "DOUBLE":
    case "BIGINT":
    case "LONG":
    case "INT":
      return value ? Number(value) : 0;
    case "MAP":
      return value ? JSON.parse(value) : {};
    case "ARRAY":
      return value ? JSON.parse(value) : [];
    case "STRUCT":
      return value ? JSON.parse(value) : {};
    case "STRING":
    case undefined:
    default:
      return value ?? "";
  }
}
